// Компонент который показывает список улиц

'use client';

import { useState, useCallback } from 'react';
import 'react-dadata/dist/react-dadata.css';
import { AddressSuggestions, DaDataSuggestion, DaDataAddress } from 'react-dadata';
import { Search } from 'lucide-react'; // ✨ "ФИШКА": Добавляем иконку для красоты

type AddressSearchProps = {
  onAddressSelected: (coords: [number, number], district?: string) => void;
};

export function AddressSearch({ onAddressSelected }: AddressSearchProps) {
  const [query, setQuery] = useState<DaDataSuggestion<DaDataAddress> | undefined>(undefined);
  const [error, setError] = useState<string | null>(null);

  // ✅ ОПТИМИЗАЦИЯ: Оборачиваем обработчик в useCallback
  const handleChange = useCallback((suggestion?: DaDataSuggestion<DaDataAddress>) => {
    setQuery(suggestion);
    if (!suggestion) return;

    console.log('DaData Full Suggestion:', suggestion.data);

    const { geo_lat, geo_lon } = suggestion.data;
    const districtData = suggestion.data as DaDataAddress & {
      city_district?: string;
      // Иногда район лежит просто в city_district (например "Кировский")
      // А иногда в city_district_with_type (например "Кировский р-н")
      city_district_with_type?: string; 
    };
    const district =
      districtData.city_district || 
      districtData.city_district_with_type || 
      // Если это область/пригород, можно попробовать другие поля, но для города хватит city_district
      undefined;

    if (geo_lat && geo_lon) {
      setError(null);
      // Передаем найденный район наверх
      onAddressSelected([parseFloat(geo_lat), parseFloat(geo_lon)], district);
    } else {
      setError('Не удалось определить координаты для этого адреса.');
    }
  }, [onAddressSelected]);

  return (
    <div className="w-full max-w-md">
      {/* ✅ ДОСТУПНОСТЬ: Добавляем невидимый label */}
      <label htmlFor="address-search-input" className="sr-only">
        Поиск адреса в Томске
      </label>
      <div className="relative">
        {/* ✨ "ФИШКА": Иконка внутри поля ввода */}
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
        
        <AddressSuggestions
          token={process.env.NEXT_PUBLIC_DADATA_API_KEY!}
          value={query}
          onChange={handleChange}
          filterLocations={[{ city: 'Томск' }]}
          count={5}
          inputProps={{
            id: 'address-search-input', // ✅ ДОСТУПНОСТЬ: Связываем с label
            placeholder: 'Начните вводить улицу...',
            // ✅ АДАПТИВНОСТЬ И СТИЛИ: Делаем поле ввода красивым и адаптивным
            className: 'w-full rounded-md px-10 py-2 text-white bg-slate-700 border border-slate-600 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition',
          }}
          // ✅ СТИЛИЗАЦИЯ: Полностью стилизуем выпадающий список с помощью Tailwind
          containerClassName="mt-1"
          suggestionsClassName="bg-slate-700 border border-slate-600 rounded-md shadow-lg"
          suggestionClassName="p-3 text-slate-300 cursor-pointer hover:bg-slate-600 transition-colors"
          currentSuggestionClassName="bg-sky-600 text-white"
        />
      </div>
      {error && <p role="alert" className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  );
}
